import {h, Fragment} from "preact"
import { useLoadMore, useSizeOptions } from "@nosto/preact"
import { defaultConfig, sizes } from "../config"

export default function LoadMore() {
    const { to, size, total } = useSizeOptions(sizes, defaultConfig.serpSize)
    const { loadMore, href } = useLoadMore(defaultConfig.serpSize);

    return (
        <div class="ns-loadmore col-span-full row-span-1 mx-auto text-center">
            {(size < total) && 
                <a 
                    class="button mb-2"
                    href={href}                    
                    onClick={loadMore}
                >
                    Load More
                </a>
            }
            <p>
                Showing {(size < total) ? size : total} of {total}
            </p>
        </div>
    )
}